import { Modal } from "react-bootstrap";
function ModalLoadingPage({ show, hide, text }) {
  const textContent = text || "Calculating content......";
  return (
    <>
      <Modal className="modal-cover" show={show} onHide={hide} backdrop="static" keyboard={false}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Loading.....</h3>
            </div>
            <div className="modal-body">
              <p className="mb-3">
                Please wait
                <br />
                {textContent}
              </p>
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ModalLoadingPage;
